import {
    filterAutocompleteOptions,
    normalizeCompanySearch,
} from "src/v2/utils/autocomplete/filter-autocomplete-options"
import { getRootCnpj } from "src/v2/utils/cnpj-root"

export const getEconomicGroupOptions = (companies) => {
    const optionsMap = new Map()
    const sourceCompanies = Array.isArray(companies) ? companies : []

    sourceCompanies.forEach((company, index) => {
        const nomeFantasia = String(company?.NomeFantasia ?? "").trim()
        const grupoNome = String(company?.GrupoEconomico_Nome ?? "").trim()
        if (!nomeFantasia) return

        const key = nomeFantasia.toLowerCase()
        if (!optionsMap.has(key)) {
            const grupoRaiz = getRootCnpj(company?.GrupoEconomico_RaizCNPJ)

            optionsMap.set(key, {
                id: `${key}-${index}`,
                label: nomeFantasia,
                grupoEconomico: grupoNome,
                grupoEconomicoRaizCNPJ: grupoRaiz,
            })
        }
    })

    return Array.from(optionsMap.values())
        .sort((firstOption, secondOption) => firstOption.label.localeCompare(secondOption.label, "pt-BR"))
}

export const resolveEconomicGroup = (selection, options = []) => {
    if (!selection) {
        return {
            grupoEconomico: "",
            grupoEconomicoRaizCNPJ: "",
            displayLabel: "",
        }
    }

    if (typeof selection === "object") {
        return {
            grupoEconomico: selection.grupoEconomico || "",
            grupoEconomicoRaizCNPJ: selection.grupoEconomicoRaizCNPJ || "",
            displayLabel: selection.label || "",
        }
    }

    const trimmedInput = String(selection).trim()
    if (!trimmedInput) {
        return {
            grupoEconomico: "",
            grupoEconomicoRaizCNPJ: "",
            displayLabel: "",
        }
    }

    const normalizedInput = normalizeCompanySearch(trimmedInput)
    const matchingOption = options.find((option) => (
        normalizeCompanySearch(option.label) === normalizedInput
    ))

    if (matchingOption) {
        return {
            grupoEconomico: matchingOption.grupoEconomico || "",
            grupoEconomicoRaizCNPJ: matchingOption.grupoEconomicoRaizCNPJ || "",
            displayLabel: matchingOption.label || trimmedInput,
        }
    }

    return {
        grupoEconomico: trimmedInput,
        grupoEconomicoRaizCNPJ: "",
        displayLabel: trimmedInput,
    }
}

export const isEconomicGroupOptionEqualToValue = (option, value) => {
    if (!option || !value) return false
    const target = typeof value === "object" ? value.label : value

    return normalizeCompanySearch(option.label) === normalizeCompanySearch(target)
}

export const filterEconomicGroupOptions = (options, state, activeInputValue) => {
    const rawInputValue = activeInputValue ?? (typeof state === "object" ? state?.inputValue : state) ?? ""

    return filterAutocompleteOptions(options, rawInputValue, {
        filterKeys: ["label"],
        normalizeFilter: normalizeCompanySearch,
        showAllOptionsOnEmpty: true,
    })
}
